export const Printers = ['Logistica', 'Laboratorio', 'Portaria'];
